<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 28" style="enable-background:new 0 0 28 28;" xml:space="preserve">
<g>
    <circle id="primary-circle" class="st0 svg-primary-color" cx="14" cy="14" r="14" />
	<g>
		<g>
			<rect x="12" y="7.5" class="st1" width="4" height="13"/>
			<rect x="7.5" y="12" class="st1" width="13" height="4"/>
		</g>
	</g>
</g>
</svg>

</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "chooseProduct",
        computed: {
            ...mapGetters({
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
            }),

        }
    }
</script>



// WEBPACK FOOTER //
// src/common/components/svg/productList/chooseProduct.vue